import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AdminService} from '../../../../services/admin.service';
import {ReviewSuggestionListsService} from './review-suggestion-lists.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {UserService} from '../../../../services/user.service';
import { RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { SuggestionListQuery } from '../models/suggestion-list-query.model';
import { SuggestionEconomics } from '../models/suggestion-economics.model';
import { SuggestionDetail } from '../models/suggestion-list.model';

const NUMBER = 'number';





const PATH_SEPARATOR = '/';
const RESPONSE = 'response';
const CONTENT = '/content';
const WITHDRAW = '/withdraw';
const ZERO_VALUE = 0;
const DEFAULT_PAGE_SIZE = 10;
const EMPTY_TEXT = '';


const DESCRIPTION_PARAM = 'description';
const REASSIGN_PATH = '/reassign/';
const RESTORE_PATH = '/restore';
const POSTPONE_PATH = '/postpone';
const POSTPONE_UPDATE_PATH = 'postpone/update';
const DATE_SEPARATOR = '-';
const TWO_DIGIT_LIMIT = 10;
const ZERO_PREFIX = '0';
const RESPONSE_OBSERVE = 'response';
const SUGGESTION_RESPONSE_TYPE = 'text';
const ASSIGNEES_PATH = '/assignees';

@Injectable()
export class SuggestionListsService {
  private listType: string;      // Для определения типа листа: свободный, продукт или стандарт. listType: free of standard;
  private standard: null;        // If listType === standard, use standardName in template field;
  private slDraft = null;

  public deputyPlanfixTasksGroupsService: any[] = [];
  public nobodyPlanfixTasksGroupsService: any[] = [];
  firstDisableService = false;

  private fArray: any = [];
  private faleOld: any = [];
  private fakeSLArray: any = [];

  public showSuccessMsgForReviewList = false;
  public showSuccessMsgOnSLList = false;

  // SL Data
  public templateService = '';              
  public economicsService: SuggestionEconomics = null;
  public descriptionService = '';           
  public photosService: File[] = [];        
  public photoUrlsService: string[] = [];    

  // Pagination parameter constants
  private readonly PAGE_PARAM = 'page';
  private readonly SIZE_PARAM = 'size';
  private readonly IS_ACTIVE_STATUS_PARAM = 'isActiveStatus';

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private adminService: AdminService,
              private userService: UserService,
              public reviewSuggestionListsService: ReviewSuggestionListsService) {
  }

  getListType() {
    return this.listType;
  }

  getHeadingGroups() {
    return this.adminService.getAllGroupsAll();
  }


  getDeputyPlanfixTasksGroups() {
    return this.deputyPlanfixTasksGroupsService;
  }

  setDeputyPlanfixTasksGroups(dList) {
    this.deputyPlanfixTasksGroupsService = dList;
  }

  getNobodyPlanfixTasksGroups() {
    return this.nobodyPlanfixTasksGroupsService;
  }

  setNobodyPlanfixTasksGroups(dList) {
    this.nobodyPlanfixTasksGroupsService = dList;
  }


  // Use it for manage service state
  setListType(value: string) {
    this.listType = value;

    switch (this.listType) {
      case 'free':
        this.setDraft(null);
        this.setStandard(null);
        break;
      case 'standard':
        this.setDraft(null);
        break;
      case 'edit':
        this.setStandard(null);
        break;
      default:
        this.setDraft(null);
        this.setStandard(null);
        break;
    }
  }

  // STANDARDS
  hasStandard() {
    return this.standard !== null;
  }

  getStandard() {
    return this.standard;
  }

  setStandard(value) {
    this.standard = value;
  }

  // DRAFTS
  hasDraft() {
    return this.slDraft !== null;
  }

  getDraft() {
    return this.slDraft;
  }

  setDraft(draft) {
    this.slDraft = draft;
  }

  // Drafts
  addNewDraft(newDraft) {
    return this.http.post(this.apiURL.addNewDraft, newDraft, {observe: 'response'});
  }

  updateDraft(draft) {
    return this.http.patch(this.apiURL.updateDraft, draft, {observe: 'response'});
  }

  // Get my drafts list
  getDraftsByUserID(userID) {
    return this.http.get(this.apiURL.getDraftsByUserID + userID + '/drafts/', {observe: 'response'});
  }

  // Get one draft by draft ID
  getDraftByID(draftID) {
    // this.apiURL.getDraftByUserID
    return this.http.get(this.apiURL.addNewDraft + PATH_SEPARATOR + draftID, {observe: RESPONSE});
  }

  // My Suggestions lists
  addNewSL(suggestion: FormData | { name: string; description?: string }) {
    const url = this.hasDraft() ? this.apiURL.addNewSLDeleteDraft + this.getDraft().id : this.apiURL.addNewSL;
    return this.http.post(url, suggestion, { observe: RESPONSE_OBSERVE, responseType: SUGGESTION_RESPONSE_TYPE })
      .map(response => response.clone<Object>({ body: response.body ? JSON.parse(response.body) : null }));
  }

  addNewMist(id, newSL) {
      return this.http.post(this.apiURL.addNewMist + id, newSL, {observe: 'response'});
  }

  cancelSuggesionFull(id, reason){
    const cancelSL = {
      reason: reason
    };
    return this.http.patch('/backend/common/suggestions/' + id + '/cancel_approval', cancelSL, {observe: 'response'});
  }

  restoreSuggesionFull(id, reason){
    const params = new HttpParams().set(DESCRIPTION_PARAM, reason);
    return this.http.patch(this.apiURL.cancelSL + id + RESTORE_PATH, {}, {params: params, observe: RESPONSE_OBSERVE});
  }

  getSLByUserID(userID) {
    return this.http.get(this.apiURL.getSLByUserID + userID, {observe: 'response'});
  }

  getSLByUserIDWithPagination(userID: string, page: number = 0, size: number = 10, isActiveStatus: boolean = true) {
    const params = new HttpParams()
      .set(this.PAGE_PARAM, page.toString())
      .set(this.SIZE_PARAM, size.toString())
      .set(this.IS_ACTIVE_STATUS_PARAM, isActiveStatus.toString());
    
    return this.http.get(this.apiURL.getSLByUserID + userID, { 
      params: params, 
      observe: 'response' 
    });
  }

  getSLByID(suggestionId: string) {
    return this.http.get<SuggestionDetail>(this.apiURL.getSLByID + suggestionId, {observe: RESPONSE_OBSERVE});
  }

  updateContent(id: string, content: {name: string; description: string; expectedVersion: number}) {
    return this.http.patch<SuggestionDetail>(this.apiURL.getSLByID + id + CONTENT,
      content, {observe: RESPONSE_OBSERVE});
  }

  withdraw(id: string, reason: string, expectedVersion: number) {
    return this.http.patch<SuggestionDetail>(this.apiURL.getSLByID + id + WITHDRAW,
      {reason: reason, expectedVersion: expectedVersion}, {observe: RESPONSE_OBSERVE});
  }

  getAssignees(suggestionId: string) {
    return this.http.get(this.apiURL.getSLByID + suggestionId + ASSIGNEES_PATH, {observe: RESPONSE_OBSERVE});
  }

  getAllSLByUserID(groupID) {
    return this.http.get(this.apiURL.getAllSLForUser + groupID, {observe: RESPONSE});
  }

  getSLForReviewByHeadID(headID) {
    return this.http.get(this.apiURL.getAllSLForReviewForHead + headID, {observe: 'response'});
  }

  getSLForReviewByHeadIDWithPagination(headID: string, page: number = 0, size: number = 10) {
    const params = new HttpParams()
      .set(this.PAGE_PARAM, page.toString())
      .set(this.SIZE_PARAM, size.toString());
    
    return this.http.get(this.apiURL.getAllSLForReviewForHead + headID, { 
      params: params, 
      observe: 'response' 
    });
  }

  getAllSLByUserIDWithPagination(groupID: string, page: number = ZERO_VALUE,
    options: number | {size: number; query: SuggestionListQuery} = DEFAULT_PAGE_SIZE) {
    const size = typeof options === NUMBER ? options as number : (options as {size: number}).size;
    const query = typeof options === NUMBER ? null : (options as {query: SuggestionListQuery}).query;
    let params = new HttpParams()
      .set(this.PAGE_PARAM, page.toString())
      .set(this.SIZE_PARAM, size.toString());
    if (query) {
      Object.keys(query).forEach(key => {
        if (query[key]) { params = params.set(key, query[key]); }
      });
    }
    
    return this.http.get(this.apiURL.getAllSLForUser + groupID, { 
      params: params, 
      observe: RESPONSE
    });
  }

  patchWithId(path: string, params: HttpParams = new HttpParams(), body: Object = {}): Observable<any> {
    return this.http.patch(path, body, {
        params: params,
        responseType: 'json'
    });
}
  // Redirecting
  redirectSL(reason, targetDivisionID, currentSLID) {
    const params = new HttpParams().set(DESCRIPTION_PARAM, reason);
    const path = this.apiURL.redirectSL + currentSLID + REASSIGN_PATH + targetDivisionID;
    return this.http.patch(path, {}, {params: params, observe: RESPONSE_OBSERVE});
  }

  // cancel
  cancelSL(reasonText, slID) {
    const cancelSL = {
      reason: reasonText
    };
    return this.http.patch(this.apiURL.cancelSL + slID + '/cancel', cancelSL, {observe: 'response'});
  }

  postponeSL(reasonText, dateTo, suggestionId) {
    // postpone
    const postponeSL = {
      reason: reasonText,
      date: this.formatDate(dateTo)
    };

    return this.http.patch(this.apiURL.postponeSL + suggestionId + POSTPONE_PATH, postponeSL, {observe: RESPONSE_OBSERVE});
  }

  updatePostponementSL(reasonText, dateTo, suggestionId) {
    // updatePostpone
    const postponeSL = {
      reason: reasonText,
      date: this.formatDate(dateTo),
      id: suggestionId
    };

    return this.http.post(this.apiURL.postponeSL + POSTPONE_UPDATE_PATH, postponeSL, {observe: RESPONSE_OBSERVE});
  }

  private formatDate(dateTo): string {
    return dateTo.year + DATE_SEPARATOR
      + this.padDatePart(dateTo.month) + DATE_SEPARATOR
      + this.padDatePart(dateTo.day);
  }

  private padDatePart(value: number): string {
    return value < TWO_DIGIT_LIMIT ? ZERO_PREFIX + value : value.toString();
  }

  cancelPostponementSL(slID) {
    return this.http.patch(this.apiURL.postponeSL + `postpone/cancellation/${slID}`, '', {observe: 'response'});
  }

  implementSL(reasonText, slID) {
    const implementSL = {
      result: reasonText
    };
    return this.http.patch(this.apiURL.implementSL + slID + '/implement', implementSL, {observe: 'response'});
  }

  sendToPlanfix(toSend) {
    return this.http.patch(this.apiURL.addTasksToPlanfix, toSend, {observe: 'response'});
  }

  addMessageToChat(message) {
    const msg = message;
    const sListID = this.reviewSuggestionListsService.getOpenedSLID();
    const reqHeaders = new HttpHeaders({'offset': this.userService.getTimezoneOffset()});
    return this.http.post(this.apiURL.addMessageToSLChat + sListID + '/message', msg, {observe: 'response', headers: reqHeaders});
  }

  getSLChatMessages() {
    const reqHeaders = new HttpHeaders({'offset': this.userService.getTimezoneOffset()});
    const slID = this.reviewSuggestionListsService.getOpenedSLID();
    return this.http.get(this.apiURL.getSLChatHistory + slID, {observe: 'response', headers: reqHeaders});
  }

  getSLPhotos(slID: string) {
    return this.http.get(this.apiURL.getSLPhotos + slID + '/photos', {observe: 'response'});
  }

  getPhotoById(photoId: string) {
    const params = new HttpParams().set('id', photoId);
    return this.http.get(this.apiURL.getSLPhotos + 'photos', {params, responseType: 'blob', observe: 'response'});
  }

  clearSLData() {
    this.economicsService = null;
    this.templateService = EMPTY_TEXT;
    this.descriptionService = EMPTY_TEXT;
    this.photosService = [];                 
    this.photoUrlsService = [];
  }

  addPhoto(file: File): boolean {
    if (this.photosService.length >= 5 || file.size > 5 * 1024 * 1024) return false;
    
    this.photosService.push(file);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.photoUrlsService.push(e.target.result);
    };
    reader.readAsDataURL(file);
    return true;
  }

  removePhoto(index: number) {
    this.photosService.splice(index, 1);
    this.photoUrlsService.splice(index, 1);
  }

  createFormDataWithPhotos(slData: any): FormData {
    const formData = new FormData();

    const dataBlob = new Blob([JSON.stringify(slData)], { type: 'application/json' });
   
    formData.append('data', dataBlob);
    
    this.photosService.forEach(photo => {
      formData.append('photos', photo, photo.name); 
    });
    
    return formData;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/services/suggestion-lists.service.ts